import { all } from 'redux-saga/effects';
import { uploadPageSaga } from 'pages/upload.page';
import { homePageSaga } from 'pages/home.page';
import { SearchPageSaga } from 'pages/search.page/saga';
import { channelsSaga } from 'common/sagas/channels';
import { savedVideosSaga } from 'pages/saved-videos.page';
import { navigationSaga } from 'common/sagas/navigation';
import { videoBoxSaga } from 'components/video-box/saga';
import { relatedVideosSaga } from 'components/video-box/related-videos/saga';
import { saga as animatedThumbnailSaga } from 'components/video-generating/saga';
import { rateVideoSaga } from 'components/video-player/rate-video/saga';
import { videoCommentsSaga } from 'components/video-box/video-comments/saga';
import { adminSaga } from 'pages/administration.page/saga';
import { videoCarouselSaga } from 'pages/home.page/video-carousel/saga';
import { videosSaga } from 'common/sagas/videos';
import { myVideosPageSaga } from 'pages/my-videos.page/saga';
import { settingsSaga } from 'common/sagas/settings';
import { videoAttachmentsSaga } from 'components/video-box/video-attachments/saga';

export function* rootSaga() {
  yield all([
    navigationSaga(),
    videosSaga(),
    SearchPageSaga(),
    uploadPageSaga(),
    channelsSaga(),
    savedVideosSaga(),
    homePageSaga(),
    videoBoxSaga(),
    relatedVideosSaga(),
    rateVideoSaga(),
    videoCommentsSaga(),
    adminSaga(),
    videoCarouselSaga(),
    myVideosPageSaga(),
    settingsSaga(),
    videoAttachmentsSaga(),
    animatedThumbnailSaga(),
  ]);
}
